import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const AddDesignationModal = ({ onSubmit, designationData }) => {
  const [designationName, setDesignationName] = useState("");
  const [designationNameError, setDesignationNameError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const submitButtonRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (designationData) {
      setDesignationName(designationData.designation);
      setDesignationNameError("");
    } else {
      setDesignationName("");
      setDesignationNameError("");
    }
  }, [designationData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!designationName || !designationName.trim()) {
      setDesignationNameError("Designation Name is required");
      return;
    }

    if (designationName.trim().length > 80) {
      setDesignationNameError("Designation Name must not exceed 80 characters");
      return;
    }

    try {
      let response;
      if (designationData) {
        response = await axios.put(
          `${apiUrl}/designations/update/${designationData.id}`,
          {
            designation: designationName,
            date: new Date().toISOString(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Designation updated successfully!");
      } else {
        response = await axios.post(
          `${apiUrl}/designations/add`,
          {
            designation: designationName,
            date: new Date().toISOString(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Designation added successfully!");
      }

      const updatedDesignation = response;
      onSubmit(updatedDesignation);

      if (submitButtonRef.current) {
        submitButtonRef.current.click();
      }

      setDesignationName("");
      setDesignationNameError("");
    } catch (error) {
      alert(error);
      let errorMessage = "Failed to perform the operation. Please try again later.";
      if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }
      toast.error(errorMessage);
      console.error("Error:", error);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setDesignationName(value);

    if (!value.trim()) {
      setDesignationNameError("Designation Name is required");
    } else {
      setDesignationNameError("");
    }
  };

  return (
    <>
     <div
  id="add_designation"
  className={`modal custom-modal fade ${showModal ? "show" : ""}`}
  role="dialog"
>
  <div
    className="modal-dialog modal-lg"
    style={{
      margin: 0,
      position: "fixed",
      right: 0,
      height: "100vh",
      width: "40%",
    }}
  >
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title">
          {designationData ? "Edit Designation" : "Add Designation"}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => setShowModal(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
      >
        <div className="form-group row mb-3">
          <label className="col-md-4 col-form-label">
            Designation Name <span className="text-danger">*</span>
          </label>
          <div className="col-md-8">
            <input
              type="text"
              className={`form-control ${
                designationNameError && "is-invalid"
              }`}
              value={designationName}
              onChange={handleChange}
              name="designationName"
            />
            {designationNameError && (
              <div className="invalid-feedback">{designationNameError}</div>
            )}
          </div>
        </div>
        <hr style={{ border: "0.5px solid #ddd" }} /> {/* Light horizontal line */}
      </div>
      <div className="modal-footer">
        <button
          type="button"
          ref={submitButtonRef}
          className="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Close
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          {designationData ? "Save Changes" : "Save"}
        </button>
      </div>
    </div>
  </div>
</div>

    </>
  );
};

export default AddDesignationModal;
